<div class="environment-management">
  <!-- 工具列 -->
  <div class="toolbar">
    <div class="row align-items-center">
      <div class="col-md-6">
        <div class="search-box">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="搜尋公司名稱、域名或客戶ID..."
              [(ngModel)]="searchTerm"
              (keyup.enter)="onSearchClick()">
            <button class="btn btn-outline-secondary" type="button" (click)="onSearchClick()">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn btn-primary" (click)="addEnvironment()">
          <i class="fas fa-plus me-2"></i>新增公司
        </button>
      </div>
    </div>
  </div>

  <!-- 載入中 -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="text-center">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">載入中...</span>
      </div>
      <p class="mt-2">載入環境資料中...</p>
    </div>
  </div>

  <!-- 環境列表 -->
  <div *ngIf="!isLoading" class="environments-list">
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>公司名稱</th>
            <th>公司ID</th>
            <th>域名</th>
            <th>版本</th>
            <th>部門數</th>
            <th>模組數</th>
            <th>無權限顯示</th>
            <th>MFA</th>
            <th>建立時間</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let environment of getCurrentPageItems()">
            <td>
              <div class="company-info">
                <strong>{{ environment.companyname }}</strong>
                <small class="text-muted d-block">{{ environment.title }}</small>
              </div>
            </td>
            <td>
              <span class="badge bg-secondary">{{ environment.clientId }}</span>
            </td>
            <td>
              <code>{{ environment.domain }}</code>
            </td>
            <td>{{ environment.version }}</td>
            <td>
              <span class="department-count">{{ environment.departmentCount || 0 }} 個部門</span>
            </td>
            <td>
              <button
                type="button"
                class="btn btn-link p-0 module-count-btn"
                (click)="openAssistantModal(environment)"
                title="點擊管理AI助手">
                <span class="text-primary">{{ environment.moduleCount || 0 }} 個模組</span>
              </button>
            </td>
            <td>
              <span class="badge" [class]="environment.showNoPermission ? 'bg-warning' : 'bg-success'">
                {{ environment.showNoPermission ? '顯示' : '隱藏' }}
              </span>
            </td>
            <td>
              <span class="badge" [class]="environment.security?.MFA ? 'bg-success' : 'bg-secondary'">
                {{ environment.security?.MFA ? '啟用' : '停用' }}
              </span>
            </td>
            <td>{{ environment.createdAt | date:'yyyy-MM-dd' }}</td>
            <td>
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="editEnvironment(environment)"
                  title="編輯"
                  >
                  <i class="fas fa-edit"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  (click)="deleteEnvironment(environment)"
                  title="刪除">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 無資料提示 -->
    <div *ngIf="filteredEnvironments.length === 0" class="no-data">
      <div class="text-center py-4">
        <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
        <h5 class="text-muted">沒有找到環境資料</h5>
        <p class="text-muted">嘗試調整搜尋條件或新增第一個環境配置。</p>
      </div>
    </div>

    <!-- 分頁 -->
    <div *ngIf="getTotalPages() > 1" class="pagination-container">
      <nav>
        <ul class="pagination justify-content-center">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" (click)="onPageChange(currentPage - 1)" href="#" (click)="$event.preventDefault()">上一頁</a>
          </li>
          <li *ngFor="let page of [].constructor(getTotalPages()); let i = index"
              class="page-item" [class.active]="currentPage === i + 1">
            <a class="page-link" (click)="onPageChange(i + 1)" href="#" (click)="$event.preventDefault()">{{ i + 1 }}</a>
          </li>
          <li class="page-item" [class.disabled]="currentPage === getTotalPages()">
            <a class="page-link" (click)="onPageChange(currentPage + 1)" href="#" (click)="$event.preventDefault()">下一頁</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>

<!-- 編輯模態框 -->
<div class="modal fade" [class.show]="showModal" [style.display]="showModal ? 'block' : 'none'" tabindex="-1" *ngIf="showModal">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-cog me-2"></i>
          {{ isEditing ? '編輯環境配置' : '新增環境配置' }}
        </h5>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="environmentForm" (ngSubmit)="saveEnvironment()">

          <!-- 基本資訊 -->
          <div class="section-header">
            <h6><i class="fas fa-info-circle me-2"></i>基本資訊</h6>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label">公司ID *</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="companyid"
                  placeholder="例: JSAI"
                  [readonly]="isEditing"
                  [class.bg-light]="isEditing">
                <small *ngIf="isEditing" class="form-text text-muted">
                  <i class="fas fa-lock me-1"></i>公司ID不可變更
                </small>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label">域名 *</label>
                <input type="text" class="form-control" formControlName="domain" placeholder="例: jsai">
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label">版本 *</label>
                <input type="text" class="form-control" formControlName="version" placeholder="例: 1.0.0">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">公司名稱 *</label>
                <input type="text" class="form-control" formControlName="companyname" placeholder="例: JSAI股份有限公司">
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">系統標題 *</label>
                <input type="text" class="form-control" formControlName="title" placeholder="例: JSAI">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label">版本 *</label>
                <input type="text" class="form-control" formControlName="version" placeholder="例: 1.0.0">
              </div>
            </div>
            <div class="col-md-8">
              <div class="mb-3">
                <label class="form-label">CSS檔案名稱 *</label>
                <input type="text" class="form-control" formControlName="css_file_name" placeholder="例: Default.css">
              </div>
            </div>
          </div>

          <!-- 資源設定 -->
          <div class="section-header">
            <h6><i class="fas fa-link me-2"></i>資源設定</h6>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label">Favicon *</label>
                <input type="text" class="form-control" formControlName="favicon" placeholder="assets/images/JSAI/JS-logo-circle.svg">
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label">Logo URL</label>
                <input type="text" class="form-control" formControlName="logoUrl" placeholder="assets/images/logo.png">
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label">版權資訊 *</label>
                <input type="text" class="form-control" formControlName="copyright" placeholder="© 2024 公司名稱">
              </div>
            </div>
          </div>

          <!-- 登入頁面設定 -->
          <div class="section-header">
            <h6><i class="fas fa-sign-in-alt me-2"></i>登入頁面設定</h6>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="mb-3">
                <label class="form-label">登入標題 HTML *</label>
                <textarea class="form-control" formControlName="Login_title" rows="2"
                          placeholder="<h1>公司名稱</h1> <h3>系統副標題</h3>"></textarea>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">頁面標題文字 *</label>
                <input type="text" class="form-control" formControlName="login_title_text" placeholder="歡迎來到系統">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">帳號欄位文字 *</label>
                <input type="text" class="form-control" formControlName="login_id_text" placeholder="帳號">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">密碼欄位文字 *</label>
                <input type="text" class="form-control" formControlName="login_pw_text" placeholder="密碼">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">登入按鈕文字 *</label>
                <input type="text" class="form-control" formControlName="login_text" placeholder="點此登入">
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">忘記密碼連結文字 *</label>
                <input type="text" class="form-control" formControlName="login_forget_text" placeholder="忘記密碼?">
              </div>
            </div>
          </div>

          <!-- 安全設定 -->
          <div class="section-header">
            <h6><i class="fas fa-shield-alt me-2"></i>安全設定</h6>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="mb-3">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" formControlName="mfaEnabled" id="mfaEnabled">
                  <label class="form-check-label" for="mfaEnabled">
                    啟用多重要素驗證 (MFA)
                  </label>
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">取消</button>
        <button type="button" class="btn btn-primary" (click)="saveEnvironment()" [disabled]="!environmentForm.valid">
          <i class="fas fa-save me-2"></i>{{ isEditing ? '更新' : '新增' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- 模態框背景 -->
<div class="modal-backdrop fade" [class.show]="showModal" *ngIf="showModal"></div>

<!-- AI助手管理對話視窗 -->
<div class="modal fade" [class.show]="showAssistantModal" [style.display]="showAssistantModal ? 'block' : 'none'" tabindex="-1" *ngIf="showAssistantModal">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-robot me-2"></i>
          AI助手管理 - {{ selectedCompanyId }}
        </h5>
        <button type="button" class="btn-close" (click)="closeAssistantModal()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <!-- 左側：可用的AI助手 -->
          <div class="col-md-6">
            <div class="section-header d-flex justify-content-between align-items-center mb-3">
              <h6 class="mb-0">
                <i class="fas fa-plus-circle text-success me-2"></i>
                可加入的AI助手 ({{ availableAssistants.length }})
              </h6>
              <div class="batch-actions">
                <button
                  type="button"
                  class="btn btn-sm btn-success me-2"
                  (click)="batchAddAssistants()"
                  [disabled]="!hasSelectedAvailableAssistants()"
                  title="批次加入選中的助手">
                  <i class="fas fa-plus me-1"></i>
                  批次加入 ({{ selectedAvailableAssistants.size }})
                </button>
              </div>
            </div>

            <div class="assistant-table-container">
              <div class="table-responsive">
                <table class="table table-hover table-sm">
                  <thead>
                    <tr>
                      <th width="40">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          [checked]="selectAllAvailable"
                          (change)="toggleSelectAllAvailable()"
                          [disabled]="availableAssistants.length === 0">
                      </th>
                      <th>助手名稱</th>
                      <th>assistantNo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let assistant of availableAssistants"
                        [class.selected]="selectedAvailableAssistants.has(assistant.assistantNo)"
                        (click)="toggleAvailableAssistant(assistant.assistantNo)">
                      <td (click)="$event.stopPropagation()">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          [checked]="selectedAvailableAssistants.has(assistant.assistantNo)"
                          (change)="toggleAvailableAssistant(assistant.assistantNo)">
                      </td>
                      <td>
                        <strong>{{ assistant.title }}</strong>
                      </td>
                      <td>
                        <span class="text-muted">{{ assistant.assistantNo }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div *ngIf="availableAssistants.length === 0" class="text-center text-muted py-4">
                  <i class="fas fa-check-circle fa-2x mb-2"></i>
                  <p>所有可用助手已加入</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 右側：公司已擁有的AI助手 -->
          <div class="col-md-6">
            <div class="section-header d-flex justify-content-between align-items-center mb-3">
              <h6 class="mb-0">
                <i class="fas fa-robot text-primary me-2"></i>
                已擁有的AI助手 ({{ companyAssistants.length }})
              </h6>
              <div class="batch-actions">
                <button
                  type="button"
                  class="btn btn-sm btn-danger me-2"
                  (click)="batchRemoveAssistants()"
                  [disabled]="!hasSelectedCompanyAssistants()"
                  title="批次移除選中的助手">
                  <i class="fas fa-minus me-1"></i>
                  批次移除 ({{ selectedCompanyAssistants.size }})
                </button>
              </div>
            </div>

            <div class="assistant-table-container">
              <div class="table-responsive">
                <table class="table table-hover table-sm">
                  <thead>
                    <tr>
                      <th width="40">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          [checked]="selectAllCompany"
                          (change)="toggleSelectAllCompany()"
                          [disabled]="companyAssistants.length === 0">
                      </th>
                      <th>助手名稱</th>
                      <th>assistantNo</th>
                      <th width="60">狀態</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let assistant of companyAssistants"
                        [class.selected]="selectedCompanyAssistants.has(assistant.assistantNo)"
                        (click)="toggleCompanyAssistant(assistant.assistantNo)">
                      <td (click)="$event.stopPropagation()">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          [checked]="selectedCompanyAssistants.has(assistant.assistantNo)"
                          (change)="toggleCompanyAssistant(assistant.assistantNo)">
                      </td>
                      <td>
                        <strong>{{ assistant.title }}</strong>
                      </td>
                      <td>
                        <span class="text-muted">{{ assistant.assistantNo }}</span>
                      </td>
                      <td>
                        <small class="badge bg-success" *ngIf="assistant.enable">啟用</small>
                        <small class="badge bg-secondary" *ngIf="!assistant.enable">停用</small>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div *ngIf="companyAssistants.length === 0" class="text-center text-muted py-4">
                  <i class="fas fa-robot fa-2x mb-2"></i>
                  <p>尚未加入任何助手</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeAssistantModal()">取消</button>
        <button type="button" class="btn btn-primary" (click)="saveAssistantConfig()">
          <i class="fas fa-save me-2"></i>存檔
        </button>
      </div>
    </div>
  </div>
</div>

<!-- AI助手管理對話視窗背景 -->
<div class="modal-backdrop fade" [class.show]="showAssistantModal" *ngIf="showAssistantModal"></div>

<!-- 刪除密碼驗證對話視窗 -->
<div class="modal fade" [class.show]="showDeleteModal" [style.display]="showDeleteModal ? 'block' : 'none'" tabindex="-1" *ngIf="showDeleteModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-shield-alt me-2"></i>
          安全驗證
        </h5>
        <button type="button" class="btn-close" (click)="closeDeleteModal()"></button>
      </div>
      <div class="modal-body">
        <form (ngSubmit)="confirmDelete()" #deleteForm="ngForm">
          <div class="alert alert-warning">
            <i class="fas fa-exclamation-triangle me-2"></i>
            您即將刪除公司「<strong>{{ environmentToDelete?.companyname }}</strong>」的所有資料，此操作無法復原。
          </div>

          <div class="mb-3">
            <label for="deletePassword" class="form-label">請輸入管理員密碼：</label>
            <input
              type="password"
              class="form-control"
              id="deletePassword"
              name="deletePassword"
              [(ngModel)]="deletePassword"
              placeholder="請輸入密碼"
              autocomplete="off"
              [class.is-invalid]="deletePasswordError"
              (keyup.enter)="confirmDelete()">
            <div class="invalid-feedback" *ngIf="deletePasswordError">
              {{ deletePasswordError }}
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeDeleteModal()">取消</button>
        <button
          type="button"
          class="btn btn-danger"
          (click)="confirmDelete(); $event.preventDefault(); $event.stopPropagation()"
          [disabled]="!deletePassword">
          <i class="fas fa-trash me-2"></i>確認刪除
        </button>
      </div>
    </div>
  </div>
</div>

<!-- 刪除密碼驗證對話視窗背景 -->
<div class="modal-backdrop fade" [class.show]="showDeleteModal" *ngIf="showDeleteModal"></div>
